<script setup lang="ts">
import LoadingCard from '../ui-elements/loaders/LoadingCard.vue';

const props = defineProps<{
  title?: string
  message?: string
}>()
</script>
<template>
  <v-card class="pa-10 rounded-lg">
    <v-card-title class="text-center text-h5 mb-6"> {{ title || 'Processing' }} </v-card-title>
    <v-card-text class="d-flex justify-center text-primary text-center my-10">
      <LoadingCard :size="100" />
    </v-card-text>
    <v-card-text class="text-center mb-10 pwt-loading-message-text">
      {{ message || "We're getting things ready for you..." }}
    </v-card-text>
  </v-card>
</template>
